import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-product-image',
  templateUrl: './product-image.component.html',
  styleUrls: ['./product-image.component.scss'],
})
export class ProductImageComponent implements OnChanges {
  @Input('image_url') public image_url: string;
  @Input('size') public size: string;
  @Input() public fallback = 'assets/images/default/product.png';
  public currentImageUrl = this.fallback;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['image_url'] || changes['fallback']) {
      this.currentImageUrl = this.image_url || this.fallback;
    }
  }

  onImageError(): void {
    if (this.currentImageUrl !== this.fallback) {
      this.currentImageUrl = this.fallback;
    }
  }
}
